export default __webpack_public_path__ + "static/media/in.ab3ca218.svg";